import { atom } from "jotai";

export const durationAtom = atom<number | undefined>(undefined);

export const lessonTypeIdAtom = atom<string | undefined>(undefined);
